import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { ChallengesView } from "@/components/challenges/ChallengesView";
import { useNoIndex } from "@/hooks/useCanonicalTag";

export default function Challenges() {
  useNoIndex();
  return (
    <CandidateLayout>
      <ChallengesView />
    </CandidateLayout>
  );
}
